import React from 'react'
import { Link } from 'react-router-dom'
import MessageUtils from '../../../util/MessageUtils'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import TaskDetailTopSF from './TaskDetailTopSF'
import TaskDetailBottomSF from './TaskDetailBottomSF'
import './TaskDetail.css'

const TaskDetailUI = ({context, messageList, project, task, onCopyClick, onTaskListUpdated,
    onForceTaskListRefresh, onForceProjectUserListRefresh,
    statusList, priorityList, projectUserList, projectUserMap,
  }) =>
  <div className='c_tsk_dtl no_scroll'>
    <TaskDetailTitleUI
      context={context}
      messageList={messageList}
      onCopyClick={onCopyClick}
      task={task}
    />

    {
      (!statusList || !priorityList) &&
      <SpinnerComponentUI />
    }

    {
      statusList && priorityList &&
      <TaskDetailTopSF
        context={context}
        messageList={messageList}
        statusList={statusList}
        priorityList={priorityList}
        projectUserMap={projectUserMap}
        projectUserList={projectUserList}
        onTaskListUpdated={onTaskListUpdated}
        onForceTaskListRefresh={onForceTaskListRefresh}
        onForceProjectUserListRefresh={onForceProjectUserListRefresh}
        project={project}
        task={task}
      />
    }

    <TaskDetailBottomSF
      context={context}
      messageList={messageList}
      projectUserMap={projectUserMap}
      projectUserList={projectUserList}
      onForceTaskListRefresh={onForceTaskListRefresh}
      project={project}
      task={task}
    />
  </div>

const TaskDetailTitleUI = ({context, messageList, onCopyClick, task}) =>
  <div className='title'>
    [{task.taskNumber}] {task.taskName}
    <div className='icon icon-clone g_link_2'
      onClick={onCopyClick}
      data-tip={MessageUtils.getMessageValue(messageList, 'c_copy_link')}
    />
    <Link to={`/tasks/${task.taskNumber}`}>
      <div className='icon icon-external-link' />
    </Link>
  </div>

export default TaskDetailUI
